module.exports = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"page-container\">\n      <div class=\"ot-error-container\">\n        <p>{{vm.type}}!</p>\n        <h1>{{vm.title | translate}}</h1>\n      </div>\n    </div>\n  </div>\n</div>\n<ot-footer></ot-footer>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/components/accessRouteErr.html
 ** module id = 236
 ** module chunks = 1
 **/